import logger from "../../apps/root/assets/js/logger";
export default function QuickDeposit(){
    
    const Nav = new Navigation();
    const hero = document.getElementById('hero');
    const form = document.querySelector('form[name="cryptodeposit"]');
    const deposit_options = form?.querySelectorAll('#deposit_crypto .crypto');
    const quick_deposit_open = document.querySelectorAll('[data-toggle="quick_deposit"]');
    const quick_deposit_close = document.querySelectorAll('.quick_deposit .close');
    const more_cryptos_trigger = document.querySelector('span[data-toggle="more-cryptos"]');
    const btnDeposit = document.getElementById('quick_deposit_btn');
    const depositOptionsInputs = document.querySelectorAll('input[name="invoice_currency"]');

    // QD opened or not
    const isOpened = () => {
        return hero.dataset.show === 'quick_deposit';
    }

    // Listen clicks on all deposit options
    const listenOptionsSelect = () => {
        deposit_options.forEach(btn => {
            btn.addEventListener('click', (e) => onDepositSelect(btn, e));
        });
    }

    // React on selected deposit option
    const onDepositSelect = (btn, e) => {
        e.stopImmediatePropagation();
        logger.log('Selected deposit option: ' + btn.querySelector('input[name="invoice_currency"]').value);
        clearAnyDepositOptionCheck();
        checkDepositOption(btn);
    }

    // Clear all deposit options check
    const clearAnyDepositOptionCheck = () => {
        deposit_options.forEach(btn => {
            btn.classList.remove('selected');
            btn.querySelector('input[name="invoice_currency"]').removeAttribute('checked');
        })
        logger.log('Cleared any deposit option that was chceked');
    }

    // Check selected deposit option
    const checkDepositOption = (btn) => {
        btn.classList.add('selected');
        btn.querySelector('input[name="invoice_currency"]').setAttribute('checked', 'checked');
        logger.log('Checked deposit option: ' + btn.querySelector('input[name="invoice_currency"]').value);
    }

    // Listen clicks for closing QD
    const listenCloseQD = () => {
        quick_deposit_close.forEach(btn => {
            btn.addEventListener('click', btn => closeQD(btn));
        })
    }

    // Listen clicks for opening QD
    const listenOpenQD = () => {
        quick_deposit_open.forEach(btn => {
            btn.addEventListener('click', btn => openQD(btn));
        })
    }

    // Close QD
    const closeQD = () => {
        hero.dataset.show = 'promos'
        // hide crypto selectables
        toggleDepositOptionsDisplay(getDepositOptions(), false);
    }

    // Open QD
    const openQD = () => {
        logger.log('Open QD');
        logger.log(isOpened());
        // If QD is already showing hide it (but not if the trigger is from nav)
        if (isOpened() && !Nav.isOpened()) { 
            closeQD();
            return;
        }
        // If main navigation is opened
        if (Nav.isOpened()) {
            logger.log('Nav is opened');
            Nav.close();
        }
        
        // show qd box
        hero.dataset.show = 'quick_deposit';
        // show crypto selectables
        if (!isOpened()) toggleCryptosOpacity(getDepositOptions('top3'));
    }

    // Show or hide deposit options 
    const toggleDepositOptionsDisplay = function(elems, show){
        elems.forEach(elem => {
            // show ? elem.classList.add('show') : elem.classList.remove('show');
            show ? elem.style.display = "inline-flex" : elem.style.display = "none";
        });
    }

    // Get deposit options top3/all
    const getDepositOptions = (top3 = false) => {
        return top3 ? document.querySelectorAll('span.crypto')
                    : document.querySelectorAll('span.crypto:not(.top3)');
    }

    // Listen on clicks for expanding more deposit options
    const listenExpandQD = () => {
        more_cryptos_trigger.addEventListener('click', () => {
            more_cryptos_trigger.classList.contains('open') 
                ? expandQD(false)
                : expandQD(true);
        })
    }

    // Show dropdown with more deposit options
    const expandQD = (open) => {
        if (open) {
            logger.log('Expand QD.');
            more_cryptos_trigger.classList.add('open');
            toggleDepositOptionsDisplay(getDepositOptions(), true);
        } else {
            logger.log('Hide extra QD.');
            more_cryptos_trigger.classList.remove('open');
            toggleDepositOptionsDisplay(getDepositOptions(), false);
        }
        toggleCryptosOpacity(getDepositOptions());
    }

    // Effect for showing/hiding depoit options
    const toggleCryptosOpacity = async function(elems){
        if ( !elems || elems.length < 1 ) return false;
        elems.forEach(function(elem, i) {
            setTimeout(() => {
                elem.classList.toggle('show');
            }, 90*i)
        })
        return false;
    }

    const getSelectedOption = () => {
        let selectedElement;
        depositOptionsInputs.forEach((el) => {
            if(el.checked) {
                selectedElement = el;
                return;
            }
        });
        return selectedElement;
    }

    const deposit = () => {
        let selectedCurrency = getSelectedOption();
        const QDPopup = document.getElementById('popupQuickdeposit');

        const order_id = document.querySelector('input[name="order_id"]').value;
        const item_name = document.querySelector('input[name="item_name"]').value;
        const player_currency = document.querySelector('input[name="player_currency"]').value;
        const invoice_amount = parseInt(document.querySelector('input[name="invoice_amount"]').value);
        const invoice_currency = getSelectedOption().value;
        
        if (selectedCurrency.value === 'MASTER') {
            document.getElementById('quick_deposit_btn').classList.add('disabled');
            window.location.href = '/cashier?deposit&preselect=' + selectedCurrency.value;
            return;
        }

        if (selectedCurrency.value === 'visa') {
            window.open(`https://api.whitesector.com/alt/buy-crypto?cryptocurrency=bitcoin+${order_id}&PIN=${item_name}&amount=${invoice_amount}`, '_blank');
            return;
        }

        if (selectedCurrency.value === 'eft') {
            document.getElementById('quick_deposit_btn').classList.add('disabled');
            window.location.href = '/cashier?preselect=eft';
            return;
        }

        // logger.log(QDPopup);
        QDPopup.parentElement.classList.remove('hidden');

        let params = 'order_id=' + order_id + '&item_name=' + item_name + '&player_currency=' + player_currency + '&invoice_currency=' + invoice_currency + '&currency=' + player_currency + '&invoice_amount=' + invoice_amount;

        fetch('https://aonsiri.com/coinspaid/process/api-address-generator?' + params, { method: 'GET' })
        .then((response) => response.json())
        .then((data) => {
            if(data)
            populatePopup(data);
        })
        .catch((error) => {
            logger.log(error)
            let invoiceHtml = `
                <div class="row row--align-center">
                    <h3 class="text-red center">Unfortunately we couldn\'t process your deposit at this moment.</h3><br>
                    <p class="justify">No worries, you weren\'t charged for this attempt. Please try using the <a href="/cashier?deposit&ref=qd-fail">cashier</a> or contact customer support if the issue persists.</p>
                </div>`;
                    
            document.querySelector('#invoiceContent .removeOnLoad').outerHTML= invoiceHtml;
        })
    }

    const populatePopup = (data) => {let html = `
        <div class="row row--align-center row--margin-bottom-lg">
            <p class="center text-gray row--margin-bottom-md">Scan with your wallet app</p>
            <img src="https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=${data.crypto_address}&choe=UTF-8" alt="Free Chip" class="pending-freespins-game">
        </div>
        <div class="row row--align-left">
            <h3>Crypto address</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <p class="text-gray center">${data.crypto_address}</p>
        </div>
        <div class="row row--align-left row--margin-bottom-sm">
            <h3>USD</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <h3 class="text-green">$${data.amounts_fiat}</h3>
        </div>
        <div class="row row--align-left">
            <h3>Amount in ${data.crypto_currency.toUpperCase()}</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <h3 class="text-green">${data.crypto_amount}</h3>
        </div>
        <div class="row row--align-left">
            <h3>Invoice ID</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <p class="text-gray center">${data.invoice_id}</p>
        </div>
        <div class="row row--align-left">
            <h3>Username</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <p class="text-gray">${data.username}</p>
        </div>
        `;

        document.querySelector('#invoiceContent .removeOnLoad').outerHTML= html;
    }

    const createQDPopup = () => {
        const html = `
        <div class="pageoverlay hidden">
            <div class="popup__content" id="popupQuickdeposit">
                <div class="row row--align-left row--margin-bottom-md">
                    <i class="icon-back"></i>
                </div>
                <div id="invoiceContent" class="row row--align-center">
                    <h2 class="center">Complete your deposit</h2><br/>
                    <br />
                    <h4 class="center text-gray removeOnLoad">Generating your crypto address in a moment...</h4>
                </div>
            </div>
        </div>
        `;
        document.querySelector('body').insertAdjacentHTML('beforeend', html);

        document.querySelector('.pageoverlay .icon-back').addEventListener('click', function() {
            document.querySelector('.pageoverlay').classList.remove('show');
            document.querySelector('.pageoverlay').classList.add('hidden');
            document.querySelector('#invoiceContent').innerHTML = '<h2 class="center">Complete your deposit</h2><br/><br /><h4 class="center text-gray removeOnLoad">Generating your crypto address in a moment...</h4>';
        })
    }

    const populateQDPopup = (data) => {
        let html = `
        <div class="row row--align-center row--margin-bottom-lg">
            <p class="center text-gray row--margin-bottom-md">Scan with your wallet app</p>
            <img src="https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=${data.invoice_id}&choe=UTF-8" alt="Free Chip" class="pending-freespins-game">
        </div>
        <div class="row row--align-left">
            <h3>Crypto address</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <p class="text-gray">${data.crypto_address}</p>
        </div>
        <div class="row row--align-left row--margin-bottom-sm">
            <h3>USD</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <h3 class="text-green">$${data.amounts_fiat}</h3>
        </div>
        <div class="row row--align-left">
            <h3>Amount in ${data.crypto_currency.toUpperCase()}</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <h3 class="text-green">${data.crypto_amount}</h3>
        </div>
        <div class="row row--align-left">
            <h3>Invoice ID</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <p class="text-gray">${data.invoice_id}</p>
        </div>
        <div class="row row--align-left">
            <h3>Username</h3>
        </div>
        <div class="row row--align-left row--margin-bottom-md">
            <p class="text-gray">${data.username}</p>
        </div>
        `;

        document.querySelector('#invoiceContent .removeOnLoad').outerHTML= html;
    }

    // Initialize Quick Deposit module
    const init = () => {
        if(form) {
            listenOpenQD();
            listenCloseQD();
            listenExpandQD();
            listenOptionsSelect();
            createQDPopup();
            btnDeposit.addEventListener('click', deposit);
        }
    }

    return {
        init
    }
}


function Navigation() {

    const elem = () => document.getElementById('ConMenuLeft');

    const isOpened = () => elem().classList.contains('Opened');

    const btn = () => document.getElementById('BtnHamMenu');

    const wrapper = document.getElementById('Wrapper');

    const close = () => {
        logger.log('Close Nav');
        elem().classList.remove('Opened');
        wrapper.classList.remove('Blur');
        btn().classList.remove('Cross');
    }

    return {
        isOpened, elem, btn, close
    }
}